import { MenuShellItem, ThemeComponentSwitcher } from 'lib_ui-primitives';
import Gl2025MenuShell from './MenuShell.gl2025';

let MenuShell = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: Gl2025MenuShell
    },
    { component: MenuShellItem }
]);
export default MenuShell;
